import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addreason',
  templateUrl: './addreason.component.html',
  styleUrls: ['./addreason.component.css']
})
export class AddreasonComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  reasonColl: any = [];
  reasonid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  reasonform = new FormGroup({
    reasonid: new FormControl(0),
    reasonname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Reason";


  @Input() reasonname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.reasonid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.reasonform.reset();
      this.fnInitializeReason();

      if (this.reasonid > 0) {
        this.fngetReason();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.reasonid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeReason() {
    this.reasonform.setValue({

      reasonid: 0,
      reasonname: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetReason() {
   
    var data = {
      'reasonid': this.reasonid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getReason(data)
      .subscribe(
        (res) => {
          this.reasonColl = res.json().result;
          var editdata = this.reasonColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.reasonform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'reasonid': this.reasonid,
          'reasonname': this.reasonform.get('reasonname').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.reasonform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckReason(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.reasonform.get('reasonid').value > 0) {
                //Update Department
                this.fnSetReason(data);
              }
              else {
                //Insert Department
                this.fnInsertReason(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false

                this.reasonform.controls['reasonname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertReason(data) {

    this.appService.fnInsertReason(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The New Reason has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.reasonid);

          this.emitData.emit(this.reasonid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetReason(data) {

    this.appService.fnSetReason(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The Reason has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.reasonid, data.reasonname);

          this.emitData.emit(this.reasonid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.reasonform.setValue({

      reasonid: deptBO.reasonid,
      reasonname: deptBO.reasonname,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
